import { getAppLocale } from 'src/locales/utils';

export const getAppDirection = () => (getAppLocale() === 'fa' ? 'rtl' : 'ltr');

